import { useState } from 'react'

import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'

import Additional from './Additional'
import File from './File'
import Station from './Station'

const Files = (props) => {
  const { data, setData } = props

  const [tab, setTab] = useState(0)

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <>
            <Station formEdit={data} setFormEdit={setData} />
          </>
        )
      case 1:
        return (
          <>
            <Additional formEdit={data} setFormEdit={setData} />
          </>
        )
      case 2:
        return (
          <>
            <File formEdit={data} setFormEdit={setData} />
          </>
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'Fotografias estación cero',
    },
    {
      id: 1,
      title: 'Fotografias adicionales',
    },
    {
      id: 2,
      title: 'Archivos',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default Files
